import { useSelector } from "react-redux";
import { Selectors } from "@/store/user/selectors";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import isempty from "lodash/isEmpty";

type tArgs = {
  isSaloon: boolean;
};
export const usePremiumFeaturesList = ({ isSaloon }: tArgs): string[] => {
  const { i18n, ready } = useTranslation(["premium"], {
    useSuspense: false,
  });
  const isBiz = useSelector(Selectors.isBusinessMode);
  return useMemo(() => {
    if (!ready) return [];
    let tKey = "premium_feats_normal";
    if (isSaloon) tKey = "premium_feats_org";
    else if (isBiz) tKey = "premium_feats_biz";
    const options = i18n.getResource(i18n.language, "premium", tKey);
    if (isempty(options)) return [];
    if (Array.isArray(options)) return options;
    return [];
  }, [ready, i18n.language, isBiz, isSaloon]);
};
